export function formatDate(value) {
    if (!value) {
        return '-';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }
    return date.toLocaleString('de-DE');
}

export function toDateTimeValue(value) {
    if (!value) {
        return '';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    const pad = (num) => String(num).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
        date.getMinutes()
    )}`;
}

export function buildAuditSearchPayload(filters) {
    const payload = {};
    Object.entries(filters || {}).forEach(([key, value]) => {
        if (value) {
            if (key === 'from' || key === 'to') {
                const date = new Date(value);
                if (!Number.isNaN(date.getTime())) {
                    payload[key] = date.toISOString();
                }
            } else {
                payload[key] = value;
            }
        }
    });
    return payload;
}
